import { INotification, Notification } from '../Notification'
import { NotificationTypeEnum } from '../NotificationTypeEnum'
import { IEODReportCreatedEmailData } from './IEODReportCreatedEmailData'
import { NotificationClassificationEnum, User } from '../..'
import htmlTemplate from './EODReportCreatedEmailTemplate'

export interface EODReportCreatedEmail extends INotification {
  data: IEODReportCreatedEmailData
}

export class EODReportCreatedEmail extends Notification implements EODReportCreatedEmail {
  constructor(public to: User, public data: IEODReportCreatedEmailData) {
    super(to, NotificationTypeEnum.EOD_REPORT_CREATED_EMAIL, NotificationClassificationEnum.EMAIL)
  }

  public get subject() {
    return `Skilletworks End of Day Report ${ this.data.date }`
  }

  public get body() {
    return htmlTemplate
  }
}
